/* eslint-disable prettier/prettier */
import axios from 'axios'
import qs from 'qs'
import store from '@/store'
// eslint-disable-next-line no-unused-vars
import { isDev, toast } from '../utils'

let baseURL = '//mxapi.muccyapi.com'
// test/debug等环境后端请求BaseURL切换代码
if (location.host.startsWith('debug')) {        //预生产环境
  document.body.classList.add('js-is-debug')
  baseURL = '//debug-mxapi.muccyapi.com'
} else if (!['muccybook.com', 'http://muccybook.com', 'https://muccybook.com', 'http://www.muccybook.com', 'https://www.muccybook.com'].includes(location.host) && !location.host.startsWith('www.')) {       //测试环境
  document.body.classList.add('js-is-test')
  baseURL = '//test-mxapi.muccyapi.com'
}

// if (location.host.indexOf('muccybook.com') != -1) baseURL = baseURL.replace('cgyouxi.com', 'muccybook.com')

let getTokenObj = (obj = {}) => {
  if (typeof obj !== 'object') return obj
  let token = store.getters.vx_get_token || ''
  let sign = ''
  let info = { token, sign }
  if (obj instanceof FormData) {
    obj.append('token', token)
    return obj;
  }
  return Object.assign(info, obj)
}

const $axios = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
  },
  timeout: 15000
})

$axios.interceptors.request.use(config => {
  // console.log(config.noToken, config)
  if (config.method.toLowerCase() == 'post') {
    config.data = config.noToken ? config.data : getTokenObj(config.data);
    config.data = config.data instanceof FormData ? config.data : qs.stringify(config.data);
  }
  else if (!config.noToken) config.params = getTokenObj(config.params)
  return config
})

$axios.interceptors.response.use(response => {
  // console.log(response.config.noToken, response.config)
  let res = response.data
  let invalidCodes = [3700, 3701]
  if (invalidCodes.indexOf((res.message || {}).code * 1) != -1
    || invalidCodes.indexOf(res.code * 1) != -1) {
    // document.body.classList.add('js-is-outdated')
    store.commit('vx_doLogout')
  }
  return res
}, error => {
  if (error && error.response) {
    switch (error.response.status) {
      case 404:
        toast('请求链接不存在')
        break
      case 500:
        toast('服务器出错，请稍后再试')
        break
    }
  } else {
    toast('请求响应错误，请检查网络')
  }
  console.log(error.status)
  return Promise.reject(error)
})

export default $axios
